import type { KAPLAYCtx } from '../types.ts'
import { useLang } from '../providers/i18n/i18n.ts'
import { getTiledSize } from '../utils.ts'

export function useRotateScreenScene(k: KAPLAYCtx) {
  const { getLangString } = useLang(k)

  k.scene('rotateScreen', () => {

    k.loadSprite('rotateDevice', `sprites/scenes/rotate-device.png`)

    const halfWidth = k.width() / 2
    const halfHeight = k.height() / 2

    k.add([
      k.pos(0, 0),
      k.rect(k.width(), k.height()),
      k.color(k.Color.fromHex('#5F168E')),
      k.layer('background'),
    ])

    k.add([
      k.sprite('rotateDevice', {
        width: getTiledSize(4),
        height: getTiledSize(3),
      }),
      k.anchor('bot'),
      k.pos(halfWidth, halfHeight - 4),
    ])

    k.add([
      k.text(getLangString('rotate_screen_message'), {
        size: 12,
        font: 'Jersey10',
        align: 'center',
        lineSpacing: -2,
      }),
      k.color(k.Color.fromHex('#C4D600')),
      k.anchor('top'),
      k.pos(halfWidth, halfHeight + 4),
    ])
  })

}
